export const ISO_TO_NAME: Record<string, string> = {
  en: "English",
  es: "Spanish",
  fr: "French",
  de: "German",
  ru: "Russian",
  ja: "Japanese",
  zh: "Chinese",
  "zh-cn": "Chinese Simplified",
  "zh-hans": "Chinese Simplified",
  "zh-tw": "Chinese Traditional",
  "zh-hant": "Chinese Traditional",
  hi: "Hindi",
  pl: "Polish",
  pt: "Portuguese",
  tr: "Turkish",
  it: "Italian",
  ar: "Arabic",
  ko: "Korean",
  he: "Hebrew",
};
